export default "__VITE_ASSET__BIszqCmG__"